/**
 * Created by Mark on 18/04/2017.
 */


import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import ListItem from '../components/lists/list-item.js';
import Wizard from '../components/wizard/wizard.js';
import Steps  from '../components/wizard/assignment-steps';
import {Breadcrumb} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

export default class ClassesWizardComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
    }

    getBreadCrumb(){

        return  <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={ 'ui-886' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
        </Breadcrumb>
    }

    render(){
        return (<Layout>{this.getBreadCrumb()}<Wizard name="" stepsNavigation={true} steps={Steps} /></Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/assignment-wizard.js